import { SessionRealtimeChannelKey } from "@/ws";

/**
 * User role in the classroom
 */
export enum UserRole {
  TEACHER = "teacher",
  HELPER = "helper",
  STUDENT = "student",
}

/**
 * Data attached to presence when user enters a channel
 * Only tracks if user is online/offline in channel
 */
export interface PresenceData {
  userId: string;
  role: UserRole;
  name?: string;
}

/**
 * Represents a user in presence with their connection info
 */
export interface PresenceUser {
  connectionId: string;
  clientId: string;
  data: PresenceData;
}

/**
 * Map of connectionId -> PresenceUser for a single channel
 */
export interface ChannelPresenceMap {
  [connectionId: string]: PresenceUser;
}

/**
 * Complete presence state across all channels
 */
export interface PresenceState {
  [channelKey: string]: ChannelPresenceMap;
}

/**
 * Callback when a user enters a channel
 */
export type OnPresenceEnterCallback = (channelKey: SessionRealtimeChannelKey, user: PresenceUser) => void;

/**
 * Callback when a user leaves a channel
 */
export type OnPresenceLeaveCallback = (channelKey: SessionRealtimeChannelKey, connectionId: string, user?: PresenceUser) => void;

/**
 * Callback when a user updates their presence data
 */
export type OnPresenceUpdateCallback = (channelKey: SessionRealtimeChannelKey, user: PresenceUser) => void;

/**
 * Options for PresenceManager
 */
export interface PresenceManagerOptions {
  onPresenceEnter?: OnPresenceEnterCallback;
  onPresenceLeave?: OnPresenceLeaveCallback;
  onPresenceUpdate?: OnPresenceUpdateCallback;
}
